import {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom'; // Or useNavigate from react-router-dom if using React Router v6
import {Header} from '../../components';
import {AxiosHelperPortal, BASE_URL_WEB} from '../../utility';

const ResetPassword = () => {
  const history = useHistory(); // Or const navigate = useNavigate(); if using React Router v6
  const [formData, setFormData] = useState({
    password: '',
    confirm_password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successBanner, setSuccessBanner] = useState({
    visible: false,
    message: '',
  });

  // Effect to hide the banner after 5 seconds
  useEffect(() => {
    if (successBanner.visible) {
      const timer = setTimeout(() => {
        setSuccessBanner(prev => ({...prev, visible: false}));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successBanner.visible]);

  const handleInputChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const passwordShow = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    if (!formData.confirm_password) {
      newErrors.confirm_password = 'Confirm password is required';
    } else if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      // Handle form submission logic here
      console.log('Form data:', formData);
      const payload = {
        password: formData.password,
        confirm_password: formData.confirm_password,
      };
      const response = await AxiosHelperPortal(BASE_URL_WEB + 'reset-password?', 'post', payload);
      if (response.status === 200) {
        // Show success banner instead of alert
        setSuccessBanner({
          visible: true,
          message:
            response.data.message || 'Password reset successful. Redirecting to Dashboard...',
        });
        // Navigate to dashboard after short delay
        setTimeout(() => {
          history.replace('/dashboard'); // Or navigate('/dashboard'); if using React Router v6
        }, 2000);
      } else {
        // Handle error response
        console.error('Error resetting password:', response.data);
      }
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      {/* Success Banner */}
      {successBanner.visible && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: '#4CAF50',
            color: 'white',
            padding: '15px 25px',
            borderRadius: '4px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            zIndex: 1000,
            maxWidth: '300px',
            animation: 'slideIn 0.3s ease-out',
          }}
        >
          {successBanner.message}
        </div>
      )}
      <div className="container-fluid" style={{padding: '25px 250px'}}>
        <div className="row">
          <h1>Reset Password</h1>
        </div>
        <form onSubmit={handleSubmit} className="row _commonForm">
          <div className="form-group col-md-6 mt-5">
            <label htmlFor="password">
              Password :
              <span
                style={{
                  fontSize: '11px',
                  fontWeight: '500',
                  color: '#c3c3c3',
                  marginLeft: '5px',
                }}
              >
                minimum 8 characters
              </span>
            </label>
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              className={`form-control ${errors.password ? 'is-invalid' : ''}`}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
            />
            <div style={{marginTop: '5px'}}>
              <input type="checkbox" onChange={passwordShow} checked={showPassword} />
              <span style={{marginLeft: '5px'}}>Show</span>
            </div>
            {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
          </div>

          <div className="form-group col-md-6 mt-5">
            <label htmlFor="confirm_password">Confirm Password:</label>
            <input
              id="confirm_password"
              type={showPassword ? 'text' : 'password'}
              className={`form-control ${errors.confirm_password ? 'is-invalid' : ''}`}
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleInputChange}
            />
            {errors.confirm_password && (
              <div className="invalid-feedback d-block">{errors.confirm_password}</div>
            )}
          </div>

          <div className="col-md-12">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              Reset Password
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
